import React from 'react';
import { connect } from 'react-redux';
import { getSelectedBuildingSummary } from '../../redux/selectors/buildings';
import BackButton from './BackButton';
import FilterSection from './FilterSection';

import './explore-filter.css';

const ExploreLeft = ({ backLabel, backLink, building }) => (
  <div className="explore-filter">
    {backLabel !== null && (
      <div className="back-button">
        <BackButton backLabel={backLabel} backLink={backLink} />
      </div>
    )}
    <div className="sort-filter">
      <FilterSection building={building} />
    </div>
  </div>
);

export default connect((state, { bid }) => ({
  backLabel: state.ui.backButtonLabel,
  backLink: state.ui.backButtonLink,
  building: getSelectedBuildingSummary(state, bid),
}))(ExploreLeft);
